import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "night", toggle: () => {} });

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "night";
    return localStorage.getItem("portfolio-theme") || "night";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "night") {
      root.classList.add("theme-night");
      root.classList.remove("theme-day");
    } else {
      root.classList.add("theme-day");
      root.classList.remove("theme-night");
    }
    localStorage.setItem("portfolio-theme", theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "day" ? "night" : "day"));

  return (
    <ThemeContext.Provider value={{ theme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
